export const types = {
  CHECK_GEOJSON_FILE: "CHECK_GEOJSON_FILE",
  CHECK_GEOTIFF_FILE: "CHECK_GEOTIFF_FILE",
  RESET_CHECK_FILE_STATE: "RESET_CHECK_FILE_STATE",
  RESET_GEOJSON_CHECK_FILE: "RESET_GEOJSON_CHECK_FILE",
  RESET_GEOTIFF_CHECK_FILE: "RESET_GEOTIFF_CHECK_FILE",
  SET_PROJECT_EPSG: "SET_PROJECT_EPSG",
};
